<template>
	<div class="subtitle" v-show="subtitle.show" :style="subtitleStyle">
		<div ref="subDom">{{subtitle.text}}</div>
	</div>
</template>
<script>
export default {
	name: 'Subtitle',
	props: {
		subtitle: {
			type: Object,
			required: true
		}
	},
	computed: {
		subtitleStyle() {
			const style = {};
			style.top = `${this.subtitle.top}px`;
      style.left = `${this.subtitle.left}px`;
      style.width = `${this.subtitle.width}px`;
      style.opacity = `${this.subtitle.opacity}`;
			return style;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.subtitle.initDom(this.$refs.subDom);
		})
	}
}
</script>
<style lang="scss" scoped>
.subtitle {
	position: absolute;

	> div {
		height: auto;
		transform-origin: 0px 0px 0px;
		writing-mode: inherit;
		background-clip: text;
		white-space: pre-wrap;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/draftPreview/subtitle.vue